import React, { Fragment } from 'react';
import { PersonalInformationState } from 'src/redux/modules/user/PersonalInformation/types';
import { Fund } from '../../Exchange/types';
import If from '../../Shared/If/If';
import RMDAmount from '../RMD/RMDAmount';
import {
  getExistingRMDTotalRMD,
  getIsRMDEligible,
  getShowDashboard,
} from '../../../redux/modules/RMD/RMDSetting.selectors';
import DistributionAmount from './DistributionAmount';
import './SellFundEditor.scss';
import RasMaxAmount from '../RAS/RasMaxAmount.js';
import {
  isRAS,
  getSelectedHousehold,
  findFinancialAdvisor,
} from '../../../utils/advice/advice-utility';
import { useSelector } from 'react-redux';
import { getAdvisoryDetails } from '../../../redux/modules/advisoryDetails/advisoryDetails.selectors';
import { getAdvisors } from '../../../redux/modules/advisors/advisors.selectors';

export interface SellFundEditorProps {
  customerWebViewEnabled: boolean;
  isSalesforceRep: boolean;
  actions;
  deliveryMethod;
  fund: Fund;
  hasAPP: boolean;
  hasNotInheritedSEPOrSimpleIRA;
  marketVolatility;
  personalData: PersonalInformationState['data'];
  RMData;
  transactionLimit;
  userAddress;
}

const SellFundEditor: React.VFC<SellFundEditorProps> = ({
  customerWebViewEnabled,
  isSalesforceRep,
  actions,
  deliveryMethod,
  fund,
  hasAPP,
  hasNotInheritedSEPOrSimpleIRA,
  marketVolatility,
  personalData,
  RMData,
  transactionLimit,
  userAddress,
}) => {
  const { isFundRMDEligible } = fund;
  const isRMDEligible = useSelector(getIsRMDEligible);
  const totalRMDAMount = useSelector(getExistingRMDTotalRMD);
  const showRmdDashboardLink = useSelector(getShowDashboard);
  const households = useSelector(getAdvisoryDetails);
  const selectedHousehold = getSelectedHousehold(
    households,
    fund?.financialPlanningGroupID
  );
  const financialAdvisors = useSelector(getAdvisors);
  const financialAdvisor = findFinancialAdvisor(
    households,
    financialAdvisors,
    selectedHousehold?.externalHouseholdId
  );
  const distributionAmountClassName = isRAS(fund.productType)
    ? 'sell-fund-editor-rmd-eligible-container'
    : 'sell-fund-editor-container';
  return (
    <Fragment>
      <If test={!isFundRMDEligible || !hasNotInheritedSEPOrSimpleIRA}>
        <div className={distributionAmountClassName}>
          <If test={isRAS(fund.productType)}>
            <RasMaxAmount fund={fund} />
          </If>

          <DistributionAmount
            showHeader={isRAS(fund.productType)}
            {...{
              customerWebViewEnabled,
              isSalesforceRep,
              RMData,
              actions,
              deliveryMethod,
              fund,
              marketVolatility,
              transactionLimit,
              userAddress,
              financialAdvisor,
            }}
          />
        </div>
      </If>
      <If
        test={
          isRMDEligible && isFundRMDEligible && hasNotInheritedSEPOrSimpleIRA
        }
      >
        {!customerWebViewEnabled && isSalesforceRep ? (
          <span>
            {/*TODO: Remove when another way to check the box is found*/}
            <DistributionAmount
              showHeader
              {...{
                customerWebViewEnabled,
                isSalesforceRep,
                RMData,
                actions,
                deliveryMethod,
                fund,
                marketVolatility,
                transactionLimit,
                userAddress,
                financialAdvisor,
              }}
            />
          </span>
        ) : (
          <span>
            <div className="sell-fund-editor-rmd-eligible-container">
              <div className="rmd-ras-withdraw-sections">
                <If test={isRAS(fund.productType)}>
                  <RasMaxAmount fund={fund} />
                </If>
                {totalRMDAMount !== 0 && showRmdDashboardLink && (
                  <RMDAmount actions={actions} fund={fund} />
                )}
              </div>
              <DistributionAmount
                showHeader
                {...{
                  customerWebViewEnabled,
                  isSalesforceRep,
                  RMData,
                  actions,
                  deliveryMethod,
                  fund,
                  marketVolatility,
                  transactionLimit,
                  userAddress,
                  financialAdvisor,
                }}
              />
            </div>
          </span>
        )}
      </If>
    </Fragment>
  );
};

export default SellFundEditor;
